import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';
import { DocumentType } from 'types/DocumentType';

import Animation from '../Animation/Animation';
import Creative from '../Creative/Creative';

const Container = styled.div`
  margin: 0;
  padding: 0;
  height: 100%;
  background: #f0f2f5;
`;

function viewForDocumentType(documentType: DocumentType) {
  switch (documentType) {
    case DocumentType.CREATIVE:
    case DocumentType.AD:
      return <Creative />;

    case DocumentType.ANIMATION:
      return <Animation />;

    default:
      return null;
  }
}

function Document() {
  useEffect(() => {
    document.title = '';
  }, []);

  return <Container>{viewForDocumentType(store.documentType)}</Container>;
}

export default observer(Document);
